import {styled, Button} from 'external/material'

const StyledButton = styled(Button)(buttonStyles as any)

function buttonStyles() {
  return {
    color: '#4e576e',
    width: '145px',
    textTransform: 'none',
    background: '#fff',
    '&:first-child': {
      'margin-left': '9px'
    },
    '&:hover': {
    background: '#eaf5ff'
    }
  }
}

export {StyledButton as default}